import { render, staticRenderFns } from "./CambioGuardiaApi.vue?vue&type=template&id=9ab2e54c"
import script from "./CambioGuardiaApi.vue?vue&type=script&lang=js"
export * from "./CambioGuardiaApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports